import linkify from "linkifyjs/html";
import { DirectiveOptions } from "vue";

export const linkified: DirectiveOptions = {
  bind: (el, binding) => {
    el.innerHTML = linkify(el.innerHTML, binding.value);
  }
};
